export default __webpack_public_path__ + "57d58509d9ee052673719106fcef1a85.svg";